import { CategoryType } from "../clothing.types";

import headIcon from "../assets/images/category/head.webp";
import maskIcon from "../assets/images/category/mask.webp";
import tShirtIcon from "../assets/images/category/t-shirt.webp";
import jacketsIcon from "../assets/images/category/jackets.webp";
import pantsIcon from "../assets/images/category/pants.webp";
import bodyIcon from "../assets/images/category/body.webp";
import shoesIcon from "../assets/images/category/shoes.webp";
import glassesIcon from "../assets/images/category/glasses.png";
import cravataIcon from "../assets/images/category/cravata.webp";
import backpackIcon from "../assets/images/category/backpack.webp";
import braceletIcon from "../assets/images/category/bracelet.webp";
import earningsIcon from "../assets/images/category/earnings.webp";
import jewelleryIcon from "../assets/images/category/jewellery.webp";
import watchIcon from "../assets/images/category/watch.webp";

export const CATEGORIES: CategoryType[] = [
  { id: "head", name: "Head", iconUrl: headIcon, size: "sm" },
  {
    id: "bracelet",
    name: "Bracelet",
    iconUrl: braceletIcon,
    size: "wide",
    iconClass: "max-w-[142px]",
  },
  {
    id: "jackets",
    name: "Jackets",
    iconUrl: jacketsIcon,
    size: "xl",
  },
  { id: "pants", name: "Pants", iconUrl: pantsIcon, size: "tall" },
  {
    id: "earnings",
    name: "Earnings",
    iconUrl: earningsIcon,
    size: "sm",
    iconClass: "max-w-[55px]",
  },
  {
    id: "t-shirt",
    name: "T-Shirt",
    iconUrl: tShirtIcon,
    size: "sm",
    iconClass: "max-w-[55px]",
  },
  {
    id: "shoes",
    name: "Shoes",
    iconUrl: shoesIcon,
    size: "sm",
    iconClass: "max-w-[55px]",
  },
  {
    id: "backpack",
    name: "Backpack",
    iconUrl: backpackIcon,
    size: "tall",
    iconClass: "max-w-[85px]",
  },
  {
    id: "jewellery",
    name: "Jewellery",
    iconUrl: jewelleryIcon,
    size: "tall",
    iconClass: "max-w-[55px]",
  },
  { id: "body", name: "Body", iconUrl: bodyIcon, size: "tall" },
  {
    id: "glasses",
    name: "Glasses",
    iconUrl: glassesIcon,
    size: "sm",
    iconClass: "max-w-[55px]",
  },
  {
    id: "cravata",
    name: "Cravata",
    iconUrl: cravataIcon,
    size: "sm",
    iconClass: "max-w-[50px]",
  },
  {
    id: "mask",
    name: "Mask",
    iconUrl: maskIcon,
    size: "sm",
    iconClass: "max-w-[46px]",
  },
  {
    id: "watch",
    name: "Watch",
    iconUrl: watchIcon,
    size: "sm",
    iconClass: "max-w-[55px]",
  },
];

export const DEFAULT_ACTIVE_CATEGORY: CategoryType = CATEGORIES[0];

export default CATEGORIES;
